import {
  settings,
  trackPageView as _trackPageView,
  trackEvent,
  trackProduct as _trackProduct,
  trackFlow,
  getUserObject,
  PromotionProps,
  PageTypes,
} from '@ds-itu-frontend-service/ds-core-npm-package';

settings.setBrand = 'dlo_ddk';

const tealiumTrackData = (window as any)['tealiumTrackData']?.();
settings.setUserObj = {
  playerId: tealiumTrackData?.player_id || undefined,
  accountType: tealiumTrackData?.account_type || 'ROED',
};

/**
 * Flow-step fields for a page view. A flow page sends a combined view via `trackFlow({ type: 'view' })`
 * — which `utag.view()`s a page_view enriched with `flow_info` — instead of a plain `trackPageView`.
 * Matches the package's `FlowObjectProps`.
 */
type PageViewFlow = {
  userFlow: string;
  flowStep: string;
  flowStepName: string;
  flowType: string;
}

type PageViewProps = {
  pageType?: PageTypes;
  eventList?: string[];
  promotion?: PromotionProps[];
}

/** Plain page view wrapper (no flow). Flow pages use `trackFlow({ type: 'view' })` instead. */
function trackPageView(props: PageViewProps): void {
  _trackPageView(props);
}

/** Product object for Tealium ecommerce tracking */
type TrackingProduct = {
  id: number;
  name: string;
  quantity: number;
  rows: number;
  type: 'Enkeltlodder' | 'Lodpakker';
  unit_price: number;
  variant: string;
}

type TrackProductProps = {
  eventList: string[];
  products: TrackingProduct[];
  cart_total?: string;
  cart_total_items?: string;
  cart_total_rows?: string;
  transaction_id?: string;
  payment_method?: string;
  currency?: string;
  promotion?: PromotionProps[];
}

function trackProduct(props: TrackProductProps): void {
  _trackProduct({
    ...props,
    products: props.products.map(p => (
      {
        ...Object.fromEntries(Object.entries(p).map(([k, v]) => [k, String(v)])),
        category: 'Klasselotteriet',
        concept: 'Klasselotteriet',
        coupon_type: 'normal',
        draws: '',
      })),
  });
}

export { settings, trackPageView, trackEvent, trackProduct, trackFlow, TrackingProduct, PromotionProps, PageViewFlow };
